<template>
  <div class="send-gift-modal" v-if="visible">
    <div class="modal-overlay" @click="handleClose"></div>
    <div class="modal-content">
      <!-- 顶部标题和头像 -->
      <div class="modal-header">
        <span class="modal-title mr-10">向</span>
        <span class="modal-title">{{ user.name }}</span>
        <div class="recipient-avatar">
          <img :src="user.avatar_large || require('@/assets/profile.png')" alt="头像" />
        </div>
        <span class="modal-title ml-10">发送礼物</span>
      </div>

      <!-- 礼物信息 -->
      <div class="gift-info">
        <div class="gift-image">
          <img :src="gift.url || gift.imageSrc" :alt="gift.name" />
        </div>
        <div class="gift-name">{{ gift.name }}</div>
      </div>

      <!-- 个人消息输入 -->
      <div class="message-input-container">
        <textarea v-model="personalMessage" class="message-input" placeholder="添加消息..." maxlength="200"
          rows="4"></textarea>
        <div class="char-count">{{ personalMessage.length }}/200</div>
      </div>

      <!-- 发送按钮 -->
      <div class="modal-footer">
        <button class="send-btn" @click="handleSendGift">
          <img src="@/assets/svg/gift.svg" alt="礼物" class="gift-icon" />
          发送礼物
        </button>
      </div>

      <!-- 关闭按钮 -->
      <div class="close-btn" @click="handleClose">
        <img src="@/assets/close.png" alt="关闭" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SendGiftModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    gift: {
      type: Object,
      default: () => ({})
    },
    user: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      personalMessage: ''
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    handleSendGift() {
      this.$emit('send', {
        gift: this.gift,
        message: this.personalMessage.trim()
      })

      // 重置表单
      this.personalMessage = ''
    }
  }
}
</script>

<style scoped>
.send-gift-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-content {
  position: relative;
  background: white;
  border-radius: 12px;
  padding: 24px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.modal-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

.recipient-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  margin-left: 12px;
  flex-shrink: 0;
}

.recipient-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.gift-info {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.gift-image {
  width: 100px;
  height: 100px;
  margin-right: 16px;
}

.gift-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.gift-name {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.message-input-container {
  position: relative;
  margin-bottom: 20px;
}

.message-input {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  resize: none;
  box-sizing: border-box;
}

.message-input:focus {
  outline: none;
  border-color: #007bff;
}

.char-count {
  position: absolute;
  bottom: 8px;
  right: 12px;
  font-size: 12px;
  color: #999;
}

.modal-footer {
  text-align: center;
}

.send-btn {
  background: #007bff;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  transition: background-color 0.2s;
}

.send-btn:hover {
  background: #0056b3;
}

.gift-icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn img {
  width: 16px;
  height: 16px;
}
</style>
